module.exports = __webpack_public_path__ + "img/report-select.f3506ddf.svg";